import BottomSheet from "@components/BottomSheet/BottomSheet"
import NumericKeyboard from "@components/NumericKeyboard/NumericKeyboard"
import PrimaryButton from "@components/PrimaryButton/PrimaryButton"
import { toCurrencyFormat } from "@lib/utils"
import { useEffect, useState, useRef } from "react"
import { useTranslation } from 'react-i18next'
import {
    Container,
    Title,
    AmountContainer,
    AmountText,
    MaxButton,
    Divider,
    ErrorText,
    KeyboardFooterContainer,
} from "./JIDRInputCard.styles.tsx"
import BottomSheetHeader from "@components/BottomSheetHeader/BottomSheetHeader"
import { JIDRCurrency } from "@components/CurrencyIcon/CurrencyIcon"

const JIDRInputCard = ({
    title,
    amount = 0,
    isAmountError = false,
    errorText,
    onMax,
    children,
    handleKeyboardPress,
    onBlur
}: {
    title?: string
    amount: number
    onMax?: () => void
    isAmountError?: boolean
    errorText?: string
    children: React.ReactNode
    handleKeyboardPress: (value: string) => void
    onBlur?: () => void
}) => {
    const { t } = useTranslation();
    const defaultTitle = t('components.jidrInputCard.defaultTitle');
    const defaultErrorText = t('components.jidrInputCard.defaultErrorText');
    const [isOpen, setIsOpen] = useState(false)
    const hasBeenOpenedRef = useRef(false)
    
    const handleOpen = () => {
        hasBeenOpenedRef.current = true
        setIsOpen(true)
    }
    
    const handleClose = () => {
        setIsOpen(false)
    }
    
    const handleMax = () => {
        onMax?.()
    }

    useEffect(() => {
        // Only call onBlur when the keyboard is closed AND it has been opened before
        if (!isOpen && hasBeenOpenedRef.current) {
            onBlur?.()
        }
    }, [isOpen])
    
    return (
        <Container>
            <Title>{title || defaultTitle}</Title>
            <AmountContainer onClick={handleOpen}>
                <JIDRCurrency />
                <AmountText $isError={isAmountError}>
                    {toCurrencyFormat(amount)}
                </AmountText>
                {onMax && <MaxButton
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        handleMax()
                    }}
                >
                    {t('components.jidrInputCard.maxButton')}
                </MaxButton>}
            </AmountContainer>
            {(isAmountError || children) && <Divider />}
            {isAmountError && <ErrorText>{errorText || defaultErrorText}</ErrorText>}
            {children}
            <BottomSheet 
                isOpen={isOpen} 
                onClose={handleClose}
                header={<BottomSheetHeader plain />}
                footer={null}
                height="48%"
                overlayOpacity={0.1}
            >
               <NumericKeyboard onChange={handleKeyboardPress} emptySpaceButton="thousand" />
               <KeyboardFooterContainer>
                    <PrimaryButton onClick={handleClose}>{t('components.jidrInputCard.continueButton')}</PrimaryButton>
                </KeyboardFooterContainer>
            </BottomSheet>
        </Container>
    )
}

export default JIDRInputCard
